import { render, staticRenderFns } from "./LsBrand.vue?vue&type=template&id=636a018c&"
import script from "./LsBrand.vue?vue&type=script&lang=js&"
export * from "./LsBrand.vue?vue&type=script&lang=js&"
import style0 from "./LsBrand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports